<p-toast position="top-center" key="tc" />

<p-splitter class="layout-main-container"
            [style]="{'height': '100%'}"
            [panelSizes]="[40, 60]"
            [panelStyle]="{'overflow': 'visible'}">
  <ng-template #panel>
    <div class="flex h-full w-full flex-col p-3">
      <div class="flex w-full flex-row items-center gap-3 p-3">
        <div class="flex gap-3">
          <p-button size="large" icon="fas fa-backward-step" (click)="onStart()" />
          <p-button size="large" [icon]="isOnPlay ? 'fas fa-pause' : 'fas fa-play'" (click)="onPlay()" />
          <p-button size="large" icon="fas fa-forward-step" (click)="onEnd()" />
        </div>

        <div class="ml-auto flex gap-3">
          <p-iftalabel>
            <p-select [(ngModel)]="selectedSpeed" inputId="speed" [options]="speeds" optionLabel="name" (onChange)="onSpeedChanged()" />
            <label for="speed">Riproduzione</label>
          </p-iftalabel>
          <p-iftalabel>
            <input pInputText id="timer" [ngModel]="timerValue" autocomplete="off" [disabled]="true" />
            <label for="timer">Ora</label>
          </p-iftalabel>
        </div>
      </div>

      <p-slider class="mt-3 w-full" [ngModel]="playProgress" (onChange)="onSliderChanged($event)" />
      <p-divider />

      <p-tabs value="0" class="h-full w-full">
        <p-tablist>
          <p-tab value="0">Mappa</p-tab>
          <p-tab value="1">Video</p-tab>
        </p-tablist>

        <p-tabpanels class="h-full w-full">
          <p-tabpanel value="0" class="h-full w-full">
            <div class="flex h-full w-full flex-col">
              <div id="map" class="leaflet-map-container"></div>
              <div class="flex w-full flex-row items-center gap-3">
                <p-selectbutton [options]="centerOptions" [(ngModel)]="selectedCenter" optionLabel="label">
                  <ng-template #item let-item>
                    <i [class]="item.icon"></i>
                  </ng-template>
                </p-selectbutton>
              </div>
            </div>
          </p-tabpanel>

          <p-tabpanel value="1" class="h-full w-full">
            <app-video-player [timerTick]="timerTick()" [initialTime]="initialTime"
                              (metadataLoaded)="onVideoMetadataLoaded($event)"
                              (messageRequest)="onMessageReceived($event)"
                              (videoStartSelected)="onVideoStartSelected($event)"/>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>

    </div>
  </ng-template>

  <ng-template #panel>
    <div class="flex h-full w-full flex-col px-3">
      <div *ngIf="loading" class="flex flex-row items-center justify-center">
        <p-progress-spinner class="ms-auto" aria-label="Caricamento" [style]="{ width: '3rem', height: '3rem' }" />
        <strong>Caricamento...</strong>
      </div>

      <div class="grid grid-cols-7 items-center gap-3 pt-3">
        <label class="text-left font-semibold">Atleta:</label>
        <label class="col-span-2 text-left">{{ item.athlete }}</label>

        <label class="col-start-5 text-left font-semibold">Squadra:</label>
        <label class="col-span-2 text-left">{{ item.team }}</label>

        <label class="text-left font-semibold">Sessione:</label>
        <label class="col-span-2 text-left">{{ item.session }}</label>

        <label class="col-start-5 text-left font-semibold">Data:</label>
        <label class="col-span-2 text-left">{{ item.date | date: 'fullDate' }}</label>
      </div>

      <p-divider />

      <div class="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-5">
        <div *ngFor="let item of measures" class="flex flex-col rounded border border-gray-300 bg-white p-2 shadow-sm">
          <label class="text-sm font-semibold text-gray-600"> {{ item.title | translate }} </label>
          <label class="text-xs text-gray-600"> {{ item.deviceType | translate }} </label>
          <label class="text-lg font-bold text-gray-900"> {{ item.measure | number: '1.2-2' }} {{ item.uom}} </label>
        </div>
      </div>

      <p-divider />

      <div class="grid grid-cols-5 items-center">
        <p-carousel class="col-span-5 col-start-1" [value]="grouped" [numVisible]="1" [numScroll]="1" [circular]="false">
          <ng-template pTemplate="item" let-item>
            <div class="m-3">
              <!--<app-graph [grafico]="item" [timestamp]="timestamp" [loading]="loading" />-->
              <app-groupedgraph [grafico]="item" [timestamp]="timestamp" [loading]="loading" />
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </ng-template>
</p-splitter>
